import reduxWebsocket from "@giantmachines/redux-websocket";

// eslint-disable-next-line no-unused-vars
import { newSocket, newSocketCustom, newSocketDefault, Socket } from "./socket";
import { buildSocketUrl } from "./socketConfig";
import { Prefixs } from "./socketPrefix";
import { SocketSettings } from "./socketSettings";

export const createCameraSocket = (id) => {
  return newSocket(buildSocketUrl(`ws/camera/group/${id}/images`), Prefixs.CAMERA_PREFIX);
};

export const createTrainSocket = () => {
  return newSocketDefault(Prefixs.TRAIN_PREFIX);
};

export const createPredictionSocket = () => {
  return newSocketDefault(Prefixs.PREDICTION_PREFIX);
};

export const createBatchPredictionSocket = () => {
  return newSocketDefault(Prefixs.BATCH_PREDICTION_PREFIX);
};

export const createDeploymentSocket = () => {
  return newSocketDefault(Prefixs.DEPLOY_PREFIX);
};

export const createDownloadSocket = () => {
  // return newSocketDefault(Prefixs.DEPLOY_PREFIX);
  return newSocket(buildSocketUrl("ws/downloadFile"), Prefixs.DOWNLOAD_PREFIX);
};
export const createAnalysisSocket = () => {
  return newSocketDefault(Prefixs.ANALYSIS_PREFIX);
};

export const getSocketMiddlewars = () => {
  return Object.values(Prefixs).map((prefix) => {
    let prefixName = prefix.split("_")[0];
    return new reduxWebsocket({
      ...SocketSettings[prefixName],
      prefix: prefix,
    });
  });
};

export const createGroupImagesSocket = (id) => {
  return newSocket(buildSocketUrl(`ws/camera/group/${id}/images`), Prefixs.CAMERA_GROUP_PREFIX);
};
